import { DecoratorNode, LexicalEditor, NodeKey, SerializedLexicalNode } from 'lexical';
import React from 'react';

export type SerializedRichTextNode = {
  text: string;
  version: 1;
} & SerializedLexicalNode;

export class RichTextNode extends DecoratorNode<React.ReactNode> {
  __text: string;

  static getType(): string {
    return 'richtext';
  }

  static clone(node: RichTextNode): RichTextNode {
    return new RichTextNode(node.__text, node.__key);
  }

  constructor(text: string, key?: NodeKey) {
    super(key);
    this.__text = text;
  }

  createDOM(): HTMLElement {
    const dom = document.createElement('span');
    dom.innerHTML = this.__text;
    return dom;
  }

  updateDOM(prevNode: RichTextNode, dom: HTMLElement): boolean {
    if (prevNode.__text !== this.__text) {
      dom.innerHTML = this.__text;
    }
    return false;
  }

  decorate(editor: LexicalEditor, config: any): React.ReactNode {
    return <span dangerouslySetInnerHTML={{ __html: this.__text }} />;
  }

  static importJSON(serializedNode: SerializedRichTextNode): RichTextNode {
    const { text: html } = serializedNode;
    return new RichTextNode(html);
  }

  exportJSON(): SerializedRichTextNode {
    return {
      type: RichTextNode.getType(),
      text: this.__text,
      version: 1
    };
  }
}

// Helper to create a RichTextNode
export function $createRichTextNode(text: string): RichTextNode {
  return new RichTextNode(text);
}